import React from "react";
import PropTypes from "prop-types";
import { getLinkToProject } from "../../common/util/pathUtils";

const SingleColumn = ({ project, showLearnMore }) => {
    const linkToProject = getLinkToProject(project.code);

    return <div className="w-100 con-justify text-left">
				<div className="up">
					<div className="img-cover img-1 w-100">
						<a className="d-flex" href={linkToProject}><img src={project.thumbnailImageUrl} /></a>
					</div>
					<div className="px-30">
						<h6>{project.locationDescription}</h6>
						<h5><a href={linkToProject}>{project.name}</a></h5>
						<p>{project.shortDescription}</p>
					</div>
				</div>
				<div className="down px-30">
					{showLearnMore &&
					<a href={linkToProject}><span>Learn more</span>  
						<img className="ml-2" src="https://res.cloudinary.com/carbonclick/image/upload/v1648026711/Enterprise/The%20Green%20Network/Vector_xd9emm.svg" />
					</a>
					}
				</div>
			</div>
}

SingleColumn.propTypes = {
    project: PropTypes.object,
    showLearnMore: PropTypes.bool
}

export default SingleColumn;